import { render, staticRenderFns } from "./PrimaryMenuSubMenu.vue?vue&type=template&id=5bcd6d50"
import script from "./PrimaryMenuSubMenu.vue?vue&type=script&lang=js"
export * from "./PrimaryMenuSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports